import { render, staticRenderFns } from "./oss-apply-data.vue?vue&type=template&id=4f193113&scoped=true&"
import script from "./oss-apply-data.vue?vue&type=script&lang=js&"
export * from "./oss-apply-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f193113",
  null
  
)

export default component.exports